import TextInput from 'components/form/input/TextInput'
import useNotification from 'notification'
import React, { useState } from 'react'
import InscricaoEntity from 'entity/Inscricao';
import { useFieldValue } from 'components/form/input/NestedField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

export default function CampoCnpjComBuscador({ tipoPessoa, rodada, t }) {
    const [, setEmpresa] = useFieldValue("empresa");
    const { showSuccess, showError } = useNotification();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [cpfConfirm, setCpfConfirm] = useState("");
    const [inscricaoAnterior, setInscricaoAnterior] = useState(null);
    const [cpfErro, setCpfErro] = useState("");

    const carregarInscricaoAnterior = (inscricao) => {
        let empresa = { ...inscricao.empresa };
        empresa.produtosCompra = [];
        empresa.produtosVenda = [];
        setEmpresa(empresa);
    };

    const handleConfirmImport = () => {
        if (!inscricaoAnterior) return;

        // Confirma o CPF
        const cpfAnterior = inscricaoAnterior.empresa.funcionarios?.cpf

        if (cpfConfirm.replace(/\D/g, "") !== String(cpfAnterior).replace(/\D/g, "")) {
            setCpfErro("CPF não confere com a inscrição anterior.");
            return;
        }
        setCpfErro("");
        carregarInscricaoAnterior(inscricaoAnterior);
        setDialogOpen(false);
        showSuccess(t("Dados importados com sucesso!"));
    };

    const loadIncricaoAnterior = (value) => {
        InscricaoEntity.buscaInscricoesAntigas(value, rodada?.uid).then((inscricoes) => {
            if (inscricoes && inscricoes.length > 0) {
                setInscricaoAnterior(inscricoes[0]);
                setDialogOpen(true);
            }
        });
    };

    return (
        <>
            <TextInput
                sx={{ flex: 2 }}
                name="empresa.cnpj"
                label={tipoPessoa === "CPF" ? "Pessoa Física" : "Pessoa Jurídica"}
                mask={!tipoPessoa || (rodada && rodada.rodadaInternacional === "SIM")
                    ? ""
                    : tipoPessoa === "CPF"
                        ? "000.000.000-00"
                        : "00.000.000/0000-00"
                }
                required={rodada && rodada.rodadaInternacional === "SIM" ? false : true}
                onBlur={(value) => {
                    loadIncricaoAnterior(value);
                }}
            />
            <Dialog open={dialogOpen && !!inscricaoAnterior} onClose={() => setDialogOpen(false)}>
                <DialogTitle>{t("Inscrição anterior encontrada!")}</DialogTitle>
                <DialogContent>
                    <div style={{ marginBottom: 12 }}>
                        <p>{t("Deseja importar todos os dados da inscrição anterior?")}</p>
                        <TextField
                            label={t("Digite o CPF do participante para confirmar:")}
                            value={cpfConfirm}
                            onChange={e => setCpfConfirm(e.target.value)}
                            fullWidth
                            margin="dense"
                            error={!!cpfErro}
                            helperText={cpfErro}
                            placeholder="CPF"
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmImport} variant="contained" color="primary">{t("Importar dados")}</Button>
                    <Button onClick={() => setDialogOpen(false)} variant="outlined">{t("Cancelar")}</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
